import { render, staticRenderFns } from "./FreepassCard.vue?vue&type=template&id=4c01ea53&scoped=true"
import script from "./FreepassCard.vue?vue&type=script&lang=js"
export * from "./FreepassCard.vue?vue&type=script&lang=js"
import style0 from "./FreepassCard.vue?vue&type=style&index=0&id=4c01ea53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01ea53",
  null
  
)

export default component.exports